import 'css-chunksrc/client/scenes/taskStatus/status/list/styles.scss';export default {
  "list": "_list_1qftr_1",
  "item": "_item_1qftr_8",
  "square": "_square_1qftr_18",
  "paragraph": "_paragraph_1qftr_25"
};